export default __webpack_public_path__ + "static/media/GoogleIcon.edd3209d.svg";